module.exports = __webpack_public_path__ + "Fowl.0ab0d62.glb";